<script>
export default {
  name: "DeleteButton",
  props: {
    deleteFunc: Function,
  },
  methods: {
    confirm() {
      this.$confirm.require({
        message: 'Do you wish to delete this record?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectProps: {
          label: 'Cancel',
          severity: 'secondary',
          outlined: true
        },
        acceptProps: {
          label: 'Delete'
        },
        accept: () => {
          this.$toast.add({severity: 'success', summary: 'Confirmed', detail: 'Customer Deleted', life: 3000});
          this.deleteFunc();
          this.$emit('update');
        },
        reject: () => {
          this.$toast.add({severity: 'error', summary: 'Rejected', detail: 'Deletion canceled', life: 3000});
        }
      });
    }
  }
};
</script>

<template>
  <Toast/>
  <ConfirmDialog></ConfirmDialog>
  <Button @click="confirm()" class="w-fit" label="Delete" severity="danger" size="small" outlined/>
</template>
